import { AlphaVBoxOutlineIcon } from './AlphaVBoxOutlineIcon';

/**
 * author: Contributors
 * id 784EF15E-8476-47B9-BACA-D440F60A371E
 * name alpha-v-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-v-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetVBoxOutlineIcon = AlphaVBoxOutlineIcon;
export default AlphabetVBoxOutlineIcon